export default {
  "id": 15477,
  "id_produto": 128,
  "id_apolice": 1007507018744,
  "id_segurado": 127770,
  "id_tomador": 2065,
  "id_corretor": 2245,
  "codigo_apolice_susep": "04111.2020.0001.0775.7018744.000000",
  "status": "EMITIDA",
  "objeto": "Na forma do § 11 do Artigo 899 da CLT, serve a presente garantia para preparo do competente recurso a ser distribuído pelo Tomador, no âmbito do Processo n.º  123, sendo o/a reclamante 123, para o tipo de Recurso 123, em trâmite perante o/a 123.<br><br>A presente apólice é emitida de acordo com as Condições estabelecidas pela Circular Susep n.º 477/13 e Ato Conjunto TST.CSJT.CGJT nº 1, de 16 de outubro de 2019.",
  "objeto_original": "Na forma do § 11 do Artigo 899 da CLT, serve a presente garantia para preparo do competente recurso a ser distribuído pelo Tomador, no âmbito do Processo n.º %TAG_INFORMAR NUMERO DO PROCESSO%, sendo o/a reclamante %TAG_INSERIR NOME DO(A) RECLAMANTE%, para o tipo de Recurso %TAG_TIPO DE RECURSO%, em trâmite perante o/a %TAG_JUIZO/VARA%.<br><br>A presente apólice é emitida de acordo com as Condições estabelecidas pela Circular Susep n.º 477/13 e Ato Conjunto TST.CSJT.CGJT nº 1, de 16 de outubro de 2019.",
  "grupo_sublimite": "Público - Jud. Trab., Jud. Recurs. e De Pagamento",
  "grupo_credito": {
    "nome": "Judiciais Trabalhistas, Recursais e Garantias de Pagamento Público",
    "titulo": "Judiciais Trabalhistas, e Garantias de Pagamento",
    "slug": "LICJUDRECUR"
  },
  "tags": [],
  "coberturas": [
    {
      "inicio_vigencia": "2020-11-24",
      "nome": "Judicial - Depósito Recursal",
      "tipo": "basica",
      "id": 453,
      "fim_vigencia": "2024-11-24",
      "premio": 190,
      "importancia_segurada": 16900,
      "dias_vigencia": 1461
    }
  ],
  "followups": [
    {
      "tipo": "TIMELINE_DATA_ENVIO_ANALISE",
      "data_hora": "2020-11-24T20:02:00+00:00",
      "descricao": "[i4pro@i4pro.com.br] Data Envio para Análise"
    },
    {
      "tipo": "TIMELINE_INICIO_ACAO_SEGURADORA_CREDITO",
      "data_hora": "2020-11-24T20:02:00+00:00",
      "descricao": "Início Ação Seguradora Crédito"
    },
    {
      "tipo": "TIMELINE_TERMINO_ACAO_SEGURADORA_CREDITO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Término Ação Seguradora Crédito"
    },
    {
      "tipo": "TIMELINE_INICIO_ACAO_SEGURADORA_SUBSCRICAO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Início Ação Seguradora Subscrição"
    },
    {
      "tipo": "TIMELINE_TERMINO_ACAO_SEGURADORA_SUBSCRICAO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Término Ação Seguradora Subscrição"
    },
    {
      "tipo": "TIMELINE_INICIO_ACAO_SEGURADORA_RESSEGURO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Início Ação Seguradora Resseguro"
    },
    {
      "tipo": "TIMELINE_TERMINO_ACAO_SEGURADORA_RESSEGURO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Término Ação Seguradora Resseguro"
    },
    {
      "tipo": "TIMELINE_INICIO_ACAO_CORRETOR_EMISSAO",
      "data_hora": "2020-11-24T20:03:00+00:00",
      "descricao": "Início Ação Corretor Emissão"
    },
    {
      "tipo": "TIMELINE_TERMINO_ACAO_CORRETOR_EMISSAO",
      "data_hora": "2020-11-24T20:04:00+00:00",
      "descricao": "Término Ação Corretor Emissão"
    },
    {
      "tipo": "TIMELINE_DATA_ENVIO_EMISSAO",
      "data_hora": "2020-11-24T20:04:00+00:00",
      "descricao": "[i4pro@i4pro.com.br] Data Envio para Emissão"
    },
    {
      "tipo": "COMUNICACAO_ACEITE_TERMOS_DECLARACAO",
      "data_hora": "2020-11-24T20:04:00+00:00",
      "descricao": "Aceite feito por: i4pro@i4pro.com.br"
    },
    {
      "tipo": "COMUNICACAO_ACEITE_TERMOS_DECLARACAO",
      "data_hora": "2020-11-24T20:15:00+00:00",
      "descricao": "Aceite de cancelamento feito por: i4pro@i4pro.com.br"
    },
    {
      "tipo": "COMUNICACAO_CORRETOR_PARA_SEGURADORA",
      "data_hora": "2020-11-24T20:15:00+00:00",
      "descricao": "Observações do corretor: Um teste para o mundo"
    }
  ],
  "timeline": {
    "proposta": {
      "data": "2020-11-24"
    },
    "credito": {
      "status": "verde",
      "tempo_seguradora": 0,
      "tempo_corretor": 0
    },
    "subscricao": {
      "status": "verde",
      "tempo_seguradora": 0,
      "tempo_corretor": 0
    },
    "resseguro": {
      "status": "verde",
      "tempo_seguradora": 0,
      "tempo_corretor": 0
    },
    "emissao": {
      "status": "verde",
      "tempo_seguradora": 0,
      "tempo_corretor": 0
    },
    "previsao": {
      "data": "2020-12-09"
    }
  },
  "acompanhamento": [
    {
      "nome": "CORRETOR",
      "descricao": "Aceite feito por: i4pro@i4pro.com.br",
      "data_hora": "2020-11-24T20:04:00+00:00"
    },
    {
      "nome": "CORRETOR",
      "descricao": "Aceite de cancelamento feito por: i4pro@i4pro.com.br",
      "data_hora": "2020-11-24T20:15:00+00:00"
    },
    {
      "nome": "CORRETOR",
      "descricao": "Observações do corretor: Um teste para o mundo",
      "data_hora": "2020-11-24T20:15:00+00:00"
    }
  ],
  "mensagem": "Proposta emitida em 24/11/2020",
  "pendencias": [],
  "tomador": {
    "nome": "VIA VAREJO S.A.",
    "representantes": [
      {
        "cnpj_cpf": "12395558818",
        "email": null,
        "nome": "ROBERTO FULCHERBERGUER"
      },
      {
        "cnpj_cpf": "04384451806",
        "email": null,
        "nome": "ORIVALDO PADILHA"
      }
    ],
    "endereco": {
      "cep": "09510125",
      "logradouro": "R Samuel Klein, 83",
      "complemento": "",
      "bairro": "Centro",
      "cidade": "São Caetano Do Sul",
      "uf": "SP"
    },
    "telefone": null,
    "nome_fantasia": "",
    "cnpj_cpf": "33041260065290",
    "grupo_economico": {}
  },
  "tomador_credito": {
    "documento": "33041260065290",
    "razao_social": "VIA VAREJO S.A.",
    "nome_fantasia": "wertwert",
    "telefone": "99999999999",
    "email": "dfgndfgng@dd.dd",
    "website": "dgfgdfgdf",
    "endereco": {
      "cep": "09510125",
      "logradouro": "Rua Samuel Klein",
      "bairro": "Centro",
      "cidade": "São Caetano do Sul",
      "uf": "SP"
    },
    "grupo_economico": {
      "socio_majoritario": true,
      "nome": "hgf@gfgf.jhj",
      "documento": "59627145041"
    },
    "socios": [],
    "representantes_legais": [
      {
        "nome": "sdfsdf",
        "documento": "59627145041",
        "cargo": "sdfsdf",
        "pep": false,
        "email": "sdds@ss.ss",
        "categorias_pep": []
      }
    ],
    "dados_bancarios": null,
    "numero_funcionarios": null,
    "fundacao": "2020-09-08",
    "tipo_sociedade": null,
    "ramo_atividade": null,
    "regime_tributario": null,
    "cnae": null,
    "faturamento_ultimo_exercicio": null,
    "capital_social": null,
    "pais_origem": null,
    "fornecedores": [],
    "clientes": [],
    "interveniente_coobrigado": "AVALISTA_PF",
    "documentos": [],
    "observacoes": null
  },
  "segurado": {
    "cnpj_cpf": "30408539020",
    "nome": "teste",
    "endereco": {
      "cep": "99999999",
      "logradouro": "Não Informado - Não Informado",
      "complemento": "Não Informado",
      "bairro": "Não Informado",
      "cidade": "Não Informado",
      "uf": "NAO_INFORMADO"
    }
  },
  "corretor": {
    "cnpj_cpf": "12656482000111",
    "nome": "WIZ CORPORATE SOLUCOES E CORRETAGEM DE SEGUROS SA"
  },
  "premio_original": 190,
  "taxa_original": 0.1,
  "comissao_corretagem_original": 25,
  "comissao_corretagem": 15,
  "validade_premio": "2020-12-09",
  "comissao_reais": 28.5,
  "sugestao_comissao": 110,
  "caso_comissionamento": 3,
  "peso_resseguro": 54,
  "dia_minimo_vencimento": 7,
  "produto_parcelamentos": [
    {
      "descricao": "à vista",
      "numero_parcelas": 1,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 0,
      "id_produto_parcela": 1292
    },
    {
      "descricao": "1+1",
      "numero_parcelas": 2,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1293
    },
    {
      "descricao": "1+2",
      "numero_parcelas": 3,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1294
    },
    {
      "descricao": "1+3",
      "numero_parcelas": 4,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1295
    },
    {
      "descricao": "1+4",
      "numero_parcelas": 5,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1296
    },
    {
      "descricao": "1+5",
      "numero_parcelas": 6,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1297
    },
    {
      "descricao": "1+6",
      "numero_parcelas": 7,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 1,
      "id_produto_parcela": 1298
    },
    {
      "descricao": "1+2 sem juros",
      "numero_parcelas": 3,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 0,
      "id_produto_parcela": 1299
    },
    {
      "descricao": "1+1 sem juros",
      "numero_parcelas": 2,
      "numero_parcela_entrada": 1,
      "coeficiente": 0,
      "juros": 0,
      "id_produto_parcela": 1300
    }
  ],
  "permissao_alterar_portal": true,
  "premio_passo5": 190,
  "taxa_passo5": 0.1,
  "comissao_percentual_passo5": 15,
  "comissao_reais_passo5": 28.5,
  "premio_minimo_passo5": 190,
  "agravamento_passo5": false,
  "tomador_serasa_relevante": false,
  "recusada_por_limite": false,
  "data_emissao": "2020-11-24"
};



// WEBPACK FOOTER //
// ./src/mocks/dummy_policy.js